import { Api } from './Api';

export default {
    /*  1. Get all data */
    getUsers(keyword = '') {
        return Api().get(`/User${keyword ? '?Keyword=' + keyword : ''}`);
    },

    /*  2. Get one column */
    getUser(id) {
        return Api().get(`/User/${id}`);
    },

    /*  3. Create one column */
    saveUser(body) {
        return Api().post(`/User`, body);
    },

    /*  4. Delete one or more columns */
    deleteUsers(users) {
        return Api().post(`/User/DeleteUser`, users);
    },

    /*  5. post one or more columns */
    postUsers(users) {
        return Api().post(`/User/PostUser`, users);
    },

    /*  6. Change Password columns */
    changePassword(body) {
        return Api().post(`/User/ChangePassword`, body);
    },

    /*  7. Reset Password columns */
    resetPassword(body) {
        return Api().post(`/User/ResetUserPassword`, body);
    },
    getUserByMail(email) {
        return Api().get(`/User/GetUserByMail?email=${email}`);
    },
    checkUserByEmail(body) {
        return Api().post(`/User/CheckUserByEmail`, body);
    },
    generateVerificationCode(id) {
        return Api().get(`/User/GenerateVerificationCode?id=${id}`);
    },
    sendNotificationForgetPassword(body) {
        return Api().post(`/User/SendNotificationForgetPassword`, body);
    },
    GetUsersByRole(roleId) {
        return Api().get(`/User/GetUsersByRole?roleId=${roleId}`);
    }
};
